class FilterMobile {
    constructor() {

        let doc = document
        this.qsa = (s, o = doc) => o.querySelectorAll(s),
            this.qs = (s, o = doc) => o.querySelector(s)


        this.$body = document.querySelector('body')
        this.$fader = document.querySelector('.screen-fader')

        this.filtermodal = {
            $close: document.querySelector('.filter-modal__close'),
            $trg: document.querySelector('.main-collections__options__filter')
        }

        this.controlFilterModal()
    }






    //? - =========================  control filtermodal  ========================= -//
    //? - =========================  control filtermodal  ========================= -//
    controlFilterModal() {
        let that = this
        function openFilterModal() {
            that.$body.classList.add('is-filtermodal')
        }
        function closeFilterModal() {
            that.$body.classList.remove('is-filtermodal')
        }

        this.filtermodal.$trg.addEventListener('click', () => {
            openFilterModal()
        })

        
        this.filtermodal.$close.addEventListener('click', () => {
            that.$body.classList.contains('is-filtermodal') ? closeFilterModal() : null
        })
        this.$fader.addEventListener('click', () => {
            that.$body.classList.contains('is-filtermodal') ? closeFilterModal() : null
        })
    }
}

if (window.innerWidth < 1025) {
    new FilterMobile()
}